import React, { ChangeEvent, Fragment, FormEvent } from "react";
import { Link } from "react-router-dom";
import { RouteComponentPropsHistory } from "../../types";
import ReactModal from "react-modal";

import { V2 } from "../../Api";
import { formatDateLocal, formatName, truncateEllipse, formatDateTimeLocalNumeric } from "../../Utilities";
import withTitle from "../withTitle";
import DelayInput from "../DelayInput";

interface IAccountingReceiptsViewState {
    isLoading: boolean | string;
    isEditDialogOpen: boolean;
    isSaving: boolean | string;
    rowError: string;

    sortColumn: string;
    sortDirection: string;

    searchOffset: number;
    searchText: string;
    searchStatus: string;
    searchType: string;

    receipts: any[];

    editId: string;
    editVendor: string;
    editTotal: string;

    [name: string]: any;
}

const PAGE_SIZE = 50;

class AccountingReceiptsView extends React.Component<RouteComponentPropsHistory<any, any>, IAccountingReceiptsViewState> {
    constructor(props: Readonly<RouteComponentPropsHistory<any, any>>) {
        super(props);

        const state: IAccountingReceiptsViewState = {
            isLoading: true,
            isEditDialogOpen: false,
            isSaving: false,
            rowError: "",

            sortColumn: (props.location.state && props.location.state.sortColumn) || "date",
            sortDirection: (props.location.state && props.location.state.sortDirection) || "desc",

            searchOffset: (props.location.state && props.location.state.searchOffset) || 0,
            searchText: (props.location.state && props.location.state.searchText) || "",
            searchStatus: (props.location.state && props.location.state.searchStatus !== undefined) ? props.location.state.searchStatus : "pending",
            searchType: (props.location.state && props.location.state.searchType !== undefined) ? props.location.state.searchType : "",

            receipts: [],

            editId: "",
            editVendor: "",
            editTotal: "",
        };

        this.state = state;

        this.handleElementChange = this.handleElementChange.bind(this);
        this.handleDialogChange = this.handleDialogChange.bind(this);
        this.openImage = this.openImage.bind(this);

        this.nextPage = this.nextPage.bind(this);
        this.previousPage = this.previousPage.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    public async componentDidMount() {
        this.loadData();
    }

    public render() {
        return (
            <div className="viewer-root">
                {this.state.isEditDialogOpen
                    ? <ReactModal
                        isOpen={this.state.isEditDialogOpen} onRequestClose={this.closeDialog}
                        overlayClassName="modal-overlay" className="modal-content" portalClassName="modal-portal"
                        bodyOpenClassName="modal-open"
                        contentLabel="Edit Receipt">
                        <form className="input-form" onSubmit={this.handleFormSubmit}>
                            <div className="info-block">
                                <header>
                                    <h3>Edit Receipt</h3>
                                </header>

                                <section>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-total">Vendor</label>
                                        <input type="text" name="editVendor" value={this.state.editVendor} onChange={this.handleDialogChange} />
                                    </div>
                                </section>
                                <section>
                                    <div className="input-form-group">
                                        <label htmlFor="frm-total">Total Amount ($)</label>
                                        <input type="number" name="editTotal" value={this.state.editTotal} onChange={this.handleDialogChange} />
                                    </div>
                                </section>
                                &nbsp;
                                {
                                    this.state.isSaving === true
                                        ? <div className="spinner lds-dual-ring" />
                                        : (typeof this.state.isSaving) === "string"
                                            ? <span className="error-text">{this.state.isSaving}</span>
                                            : ""
                                }

                                <div className="action-panel-dialog">
                                    <button type="submit" className="button green push-right text-with-icon" disabled={this.state.isSaving === true}><i className="icon-check" /><span>Save</span></button>
                                    <button type="button" className="button" disabled={this.state.isSaving === true} onClick={this.closeDialog}>Close</button>
                                </div>
                            </div>
                        </form>
                    </ReactModal>
                    : null}
                <div className="filter-control-box">
                    <DelayInput type="search" timeout={500} className="fill-space" name="searchText" value={this.state.searchText} placeholder="Search..." onChangeDelayed={this.handleElementChange} />
                    <select name="searchType" value={this.state.searchType} onChange={this.handleElementChange} disabled={!!this.state.searchText}>
                        <option value="">All Types</option>
                        <option value="hf">Health Fairs</option>
                        <option value="gas">Gas</option>
                    </select>
                    <select name="searchStatus" value={this.state.searchStatus} onChange={this.handleElementChange} disabled={!!this.state.searchText}>
                        <option value="">All</option>
                        <option value="pending">New</option>
                        <option value="handled">Handled</option>
                    </select>
                </div>
                {this.state.rowError
                    ? <div className="error-text">{this.state.rowError}<br />&nbsp;</div>
                    : null
                }
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th className="clickable col-smallest" onClick={() => this.sortByField("date")}>Date {this.sortIcon("date")}</th>
                            <th className="clickable col-smallest" onClick={() => this.sortByField("uploader")}>Uploader {this.sortIcon("uploader")}</th>
                            <th className="clickable col-smallest" onClick={() => this.sortByField("type")}>Type {this.sortIcon("type")}</th>
                            <th className="clickable" onClick={() => this.sortByField("vendor")}>Vendor {this.sortIcon("vendor")}</th>
                            <th className="clickable col-smallest" onClick={() => this.sortByField("total")}>Total {this.sortIcon("total")}</th>
                            <th className="col-200px-ellipse wrap">Note</th>
                            <th className="col-smallest" />
                            <th className="col-smallest" />
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>Receipts</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.isLoading === true
                                ? <tr><td colSpan={10}><div className="spinner spinner-center lds-dual-ring" /></td></tr>
                                : typeof this.state.isLoading === "string"
                                    ? <tr><td colSpan={10}><span className="error-text">{this.state.isLoading}</span></td></tr>
                                    : this.state.receipts.length === 0
                                        ? <tr><td colSpan={10}>No results found</td></tr>
                                        : this.state.receipts.map((a, i) => (
                                            <tr key={a.id}>
                                                <td className="inline" data-caption="Date: ">{formatDateLocal(a.timestamp)}</td>
                                                <td className="inline" data-caption="Uploader: ">{formatName(a.employee.name)}</td>
                                                <td data-caption="Type: ">{this.renderReceiptType(a)}</td>
                                                <td className="wrap" data-caption="Vendor: ">{a.vendor}</td>
                                                <td className="col-right-vt inline" data-caption="Value: ">${a.amount}</td>
                                                <td className="col-200px-ellipse wrap" data-caption="Note: ">{truncateEllipse(a.note || "", 150)}</td>
                                                <td className="col-nopad-vt">
                                                    <button type="button" className="button btn-light smaller" title="Edit..." onClick={() => this.openEditDialog(a)} disabled={a.isUpdating}>
                                                        {a.isUpdating
                                                            ? <span className="spinner lds-dual-ring-small" />
                                                            : <i className="icon-pencil" />
                                                        }
                                                    </button>
                                                </td>
                                                <td className="col-nopad-vt">
                                                    <button type="button" className="button btn-light smaller" title={a.status === 0 ? "Mark as handled" : "Mark as new"} onClick={() => this.markStatus(i, a.status === 0 ? "handled" : "pending")} disabled={a.isUpdating}>
                                                        {a.isUpdating
                                                            ? <span className="spinner lds-dual-ring-small" />
                                                            : a.status === 0
                                                                ? <i className="icon-archive" />
                                                                : <i className="icon-undo" />
                                                        }
                                                    </button>
                                                </td>
                                                <td className="col-nopad-vt">
                                                    <button type="button" className="button btn-light smaller text-with-icon" onClick={() => this.openImage(a.fileId)}><span>View</span><i className="icon-external-link" /></button>
                                                </td>
                                            </tr>
                                        ))}
                    </tbody>
                </table>
                &nbsp;
                <div className="action-panel action-panel-noflip">
                    <button className="button push-right text-with-icon" onClick={this.previousPage} disabled={this.state.searchOffset === 0}><i className="icon-angle-left" /><span>Previous</span></button>
                    <button className="button text-with-icon" onClick={this.nextPage} disabled={this.state.receipts.length < PAGE_SIZE}><span>Next</span><i className="icon-angle-right" /></button>
                </div>
            </div>
        );
    }

    private sortIcon(column: string) {
        return this.state.sortColumn === column
            ? <i className={`icon-chevron-${this.state.sortDirection === "asc" ? "up" : "down"} icon-style-smaller`} />
            : undefined
    }

    private sortByField(column: string) {
        const direction = this.state.sortColumn === column && this.state.sortDirection === "asc" ? "desc" : "asc";

        this.setState({
            sortColumn: column,
            sortDirection: direction
        }, () => this.loadData());
    }

    private async loadData() {
        try {
            this.setState({
                isLoading: true
            });

            this.saveSearchState();

            const parameters = [
                `offset=${this.state.searchOffset}`,
                `limit=${PAGE_SIZE}`,
            ];

            if (this.state.sortColumn) {
                parameters.push(`sort=${this.state.sortColumn}`);
                parameters.push(`dir=${this.state.sortDirection || "asc"}`);
            }

            if (this.state.searchText) {
                parameters.push(`q=${encodeURIComponent(this.state.searchText)}`);
            }

            if (this.state.searchStatus && !this.state.searchText) {
                parameters.push(`status=${encodeURIComponent(this.state.searchStatus)}`);
            }

            if (this.state.searchType && !this.state.searchText) {
                parameters.push(`type=${encodeURIComponent(this.state.searchType)}`);
            }

            const receipts = await V2.get<any[]>(`accounting/receipts?${parameters.join("&")}`);

            this.setState({
                isLoading: false,

                receipts,
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e || "Could not load receipts"
            });
        }
    }

    private handleElementChange(e: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            searchOffset: 0,

            [name]: value
        }, () => this.loadData());
    }

    private handleDialogChange(e: ChangeEvent<HTMLSelectElement> | ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;
        const name = e.currentTarget.name;

        this.setState({
            searchOffset: 0,

            [name]: value
        });
    }

    private async openImage(id: string) {
        // Load image into blob
        const v = await V2.get<Blob>(`files/${id}`);

        const blob = URL.createObjectURL(v);
        const wnd = window.open(blob, "file_window", "resizable=on,scrollbars=on,status=on,location=on");

        if (wnd) {
            wnd.addEventListener("unload", e => {
                if ((e.currentTarget! as Window).location.protocol === "blob:") {
                    URL.revokeObjectURL(blob);
                }
            });
        }
    }

    private nextPage() {
        this.setState(s => {
            return {
                searchOffset: s.searchOffset + PAGE_SIZE
            };
        }, () => this.loadData());
    }

    private previousPage() {
        this.setState(s => {
            return {
                searchOffset: Math.max(s.searchOffset - PAGE_SIZE, 0)
            };
        }, () => this.loadData());
    }

    private saveSearchState() {
        const currentLocation = this.props.location;
        currentLocation.state = {
            searchOffset: this.state.searchOffset,
            searchStatus: this.state.searchStatus,
            searchText: this.state.searchText,

            sortColumn: this.state.sortColumn,
            sortDirection: this.state.sortDirection
        };
        this.props.history.replace(currentLocation);
    }

    private async markStatus(index: number, status: string) {
        try {
            const row = this.state.receipts[index];
            if (!row) {
                return;
            }

            row.isUpdating = true;
            this.setState(s => ({
                receipts: s.receipts
            }));

            await V2.post(`accounting/receipts/${row.id}/status?status=${status}`);

            row.isUpdating = false;
            this.setState(s => {
                if (!this.state.searchText && this.state.searchStatus && status !== this.state.searchStatus) {
                    // No longer should be visible
                    s.receipts.splice(index, 1);
                }
                else if (status !== this.state.searchStatus) {
                    row.status = this.statusToNumber(status);
                }

                return {
                    receipts: s.receipts
                }
            });
        }
        catch (e) {
            this.setState({
                rowError: e.message || e || "Could not update row"
            });
        }
    }

    private openEditDialog(item: any) {
        this.setState({
            isEditDialogOpen: true,
            editId: item.id,
            editVendor: item.vendor,
            editTotal: item.amount
        });
    }

    private closeDialog() {
        this.setState({
            isEditDialogOpen: false
        });
    }

    private async handleFormSubmit(e: FormEvent) {
        e.preventDefault();

        try {
            this.setState({
                isSaving: true,
            })

            const data = {
                vendor: this.state.editVendor,
                amount: this.state.editTotal
            };

            await V2.patch(`accounting/receipts/${this.state.editId}`, data);

            this.setState({
                isSaving: false,
                isEditDialogOpen: false,
            }, () => this.loadData());
        }
        catch (e) {
            this.setState({
                isSaving: e.message || e || "Could not save changes"
            })
        }
    }

    private statusToNumber(status: string) {
        switch (status) {
            case "pending": return 0;
            case "handled": return 1;
            default: throw new Error("Unknown status type " + status);
        }
    }

    private renderReceiptType(receipt: any) {
        switch (receipt.type) {
            case "gas": return <Fragment>
                Gas - <small>{receipt.gas?.vehicleTag || "UNKOWN TAG"}</small><br />
                <small>{receipt.gas?.gallons || "N/A"} gal</small>
            </Fragment>;
            case "hf": return <Fragment>
                Health fair - <small>{formatDateTimeLocalNumeric(receipt.fair.date)}</small><br />
                <small><Link to={`/fairs/${receipt.fair.id}`}>{receipt.fair.name}</Link> ({receipt.fair.estimatedCount})</small>
            </Fragment>;
            default:
                return `Unknown type '${receipt.type}'`;
        }
    }
}

export default withTitle("Receipts", AccountingReceiptsView);
